/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaskWorkflowItem
 */
export interface TaskWorkflowItem {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    analytics_key: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    is_active: boolean;
}

/**
 * Check if a given object implements the TaskWorkflowItem interface.
 */
export function instanceOfTaskWorkflowItem(value: object): value is TaskWorkflowItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('analytics_key' in value) || value['analytics_key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('is_active' in value) || value['is_active'] === undefined) return false;
    return true;
}

export function TaskWorkflowItemFromJSON(json: any): TaskWorkflowItem {
    return TaskWorkflowItemFromJSONTyped(json, false);
}

export function TaskWorkflowItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskWorkflowItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'analytics_key': json['analytics_key'],
        'name': json['name'],
        'is_active': json['is_active'],
    };
}

export function TaskWorkflowItemToJSON(json: any): TaskWorkflowItem {
    return TaskWorkflowItemToJSONTyped(json, false);
}

export function TaskWorkflowItemToJSONTyped(value?: TaskWorkflowItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'analytics_key': value['analytics_key'],
        'name': value['name'],
        'is_active': value['is_active'],
    };
}

